import styles from './downloadDeliveryNoteModal.module.css'
import { fileHelpers, fileNameFromUrl, useFileActions, usePDFActions } from '../../../../../features/files'
import { FileTile, FileType, Modal, ModalId } from '../../../../../features/ui'
import { useEffect, useMemo, useState } from 'react'
import { Delivery, DeliveryMethod, DeliveryOrder } from '../../../state/types'
import { DeliveryNotePDF } from '../delivery-note-pdf/deliveryNotePDF'

type Props = {
    delivery?: Delivery
    deliveryOrder?: DeliveryOrder
}

export const DownloadDeliveryNoteModal = (props: Props) => {
    const { delivery, deliveryOrder } = props

    const [pdfName, setPdfName] = useState<string>()

    const { deliveryNoteFileName2 } = fileHelpers

    const { generatePDF } = usePDFActions()
    const { downloadFile } = useFileActions()

    useEffect(() => {
        delivery && setPdfName(deliveryNoteFileName2(delivery, deliveryOrder))
    }, [delivery, deliveryOrder])

    const isReception = useMemo(() => delivery?.method === DeliveryMethod.RECEPTION, [delivery])

    const pdfId = 'delivery-note-pdf'

    const onSubmit = () => {
        if (delivery?.deliveryNoteUrl) {
            downloadFile(delivery.deliveryNoteUrl)
        } else if (pdfName) {
            generatePDF(pdfId, pdfName)
        }
    }

    const renderHiddenPDF = () => delivery ? (
        <div className={styles.hidden}>
            <DeliveryNotePDF
                id={pdfId}
                delivery={delivery}
                deliveryOrder={deliveryOrder}
            />
        </div>
    ) : <></>

    return (
        <Modal
            modalId={ModalId.DOWNLOAD_DELIVERY_NOTE}
            title="Descargar Remito"
            submitLabel="Descargar"
            submitIcon="download"
            onSubmit={onSubmit}
        >
            {delivery?.deliveryNoteUrl ? (
                <FileTile
                    fileType={FileType.PDF}
                    fileName={fileNameFromUrl(delivery.deliveryNoteUrl)}
                />
            ) : !isReception ? (
                <>
                    <FileTile fileType={FileType.PDF} fileName={pdfName} />
                    {renderHiddenPDF()}
                </>
            ) : <></>}
        </Modal>
    )
}
